import http from '@/utils/services/http'

export default {
  lista (limit, page, filtros) {
    let url = '/api/eventos?page=' + page + '&limit=' + limit + filtros
    return http.get(url)
      .then(response => {
        return Promise.resolve(response)
      })
      .catch(({response}) => {
        return Promise.reject(response)
      })
  },
  find (id) {
    id = parseInt(id)
    if (id < 1) return Promise.reject()
    return http.get('/api/eventos/' + id)
      .then(response => {
        return Promise.resolve(response)
      })
      .catch(({response}) => {
        return Promise.reject(response)
      })
  },
  cadastro (data, id) {
    if (typeof id !== 'undefined') {
      return this.atualizacao(data, id)
    }
    return http.post('/api/eventos', data)
      .then(response => {
        return Promise.resolve(response)
      })
      .catch(({response}) => {
        return Promise.reject(response)
      })
  },
  atualizacao (data, id) {
    return http.patch('/api/eventos/' + id, data)
      .then(response => {
        return Promise.resolve(response)
      })
      .catch(({response}) => {
        return Promise.reject(response)
      })
  },
  deletar (id) {
    id = parseInt(id)
    if (id < 1) return Promise.reject()
    return http.delete('/api/eventos/' + id)
      .then(response => {
        return Promise.resolve(response)
      })
      .catch(({response}) => {
        return Promise.reject(response)
      })
  },
  buscaTipos () {
    return http.get('/api/eventos/cadastro/tipos')
      .then(response => {
        return Promise.resolve(response)
      })
      .catch(({response}) => {
        return Promise.reject(response)
      })
  },
  atualizaStatus (id, status) {
    return http.post('/api/eventos/' + id + '/status/' + status)
      .then(response => {
        return Promise.resolve(response)
      })
      .catch(({response}) => {
        return Promise.reject(response)
      })
  },
  setFotoDestaque (evento, id) {
    id = parseInt(id)
    if (id < 1) return Promise.reject()
    return http.post('/api/eventos/' + evento + '/updateFotoDestaque/' + id) // ?XDEBUG_SESSION_START=ps
      .then(response => {
        return Promise.resolve(response)
      })
      .catch(({response}) => {
        return Promise.reject(response)
      })
  },
  uploadFoto (evento, foto) {
    return http.post('/api/eventos/' + evento + '/uploadFoto', foto, {headers: {'Content-Type': 'multipart/form-data'}}) // ?XDEBUG_SESSION_START=ps
      .then(response => {
        return Promise.resolve(response)
      })
      .catch(({response}) => {
        return Promise.reject(response)
      })
  },
  deleteFoto (evento, foto) {
    return http.delete('/api/eventos/' + evento + '/foto/' + foto)
      .then(response => {
        return Promise.resolve(response)
      })
      .catch(({response}) => {
        return Promise.reject(response)
      })
  },
  atualizaDestaque (evento, value) {
    return http.post('/api/eventos/' + evento + '/destaque', {destaque: value})
      .then(response => {
        return Promise.resolve(response)
      })
      .catch(({response}) => {
        return Promise.reject(response)
      })
  }
}



// WEBPACK FOOTER //
// ./src/domain/eventos/services/index.js